export const actionsPrefix = 'QUICK_FILTER'

export const TOGGLE_SELECT_FILTER = `${actionsPrefix}/TOGGLE_SELECT_FILTER`
export const UNSELECT_ALL_FILTERS = `${actionsPrefix}/UNSELECT_ALL_FILTERS`
